/* global $, Util, alertInterface */
import { initLazyLoad } from "@api/utils_2020";
import MiniMasonry from "minimasonry";
import ( './pb23-masonry--archtrends-squared.css');

const pb23MansonyArchtrendsSquared = {
    archtrendsService: null,
    limit: 20,
    init: function () {
        Util.service(archtrendsEndpoint + "/rpc/json/Archtrends_Service_Archtrends", true, {
            exceptionHandler: alertInterface.showError,
            reflectSuccess: function(service) {
                pb23MansonyArchtrendsSquared.archtrendsService = service;
                var codes = null;
                var isLine = $('.pb23-masonry--archtrends-squared').data('isline'); 
                var idLine = $('.pb23-masonry--archtrends-squared').data('id');
				var codes = $('.pb23-masonry--archtrends-squared').data('code');
                var searchTerm = $('.pb23-masonry--archtrends-squared').data('search');
                
                if (isLine) {                    
                    pb23MansonyArchtrendsSquared.archtrendsService.getAmbientsByLine(codes, pb23MansonyArchtrendsSquared.limit, null, null, true, {
                        success: (results) => {
							UtilUi.loadTemplate("assets/components-new/pb23-masonry--archtrends-squared/pb23-masonry--archtrends-squared.tpl", function(dataContact, tpl) {
								var dataParams ={
									firstLanguage: lang,
									urlImageServer: urlImageServer,
									urlHome: urlhome,
									id: codes,
									searchTerm: searchTerm,
									isLine: isLine,
									itemslist: results,
									idLine: idLine
								};
								var rest = pb23MansonyArchtrendsSquared.limit - results.length;
								if (rest > 0)
								{
									pb23MansonyArchtrendsSquared.archtrendsService.getAmbientsByLine(codes, rest, null, null, false, {
										success: (resultsMore) => {
											console.log(resultsMore);                        
											dataParams.itemslist = results.concat(resultsMore);
											var html = tpl.fetch(dataParams);
											$('.pb23-masonry--archtrends-squared').replaceWith(html);
											initLazyLoad();
											pb23MansonyArchtrendsSquared.initMasonry();
										}
									}
									);
								}
								else
								{
									var html = tpl.fetch(dataParams);
									$('.pb23-masonry--archtrends-squared').replaceWith(html);
									initLazyLoad();
									pb23MansonyArchtrendsSquared.initMasonry();
								}
							});
                        }
                    });
                } else {
                    pb23MansonyArchtrendsSquared.archtrendsService.getAmbientsByProduct(codes.split(','), pb23MansonyArchtrendsSquared.limit, null, null, null, true, {
                        success: (results) => {
							UtilUi.loadTemplate("assets/components-new/pb23-masonry--archtrends-squared/pb23-masonry--archtrends-squared.tpl", function(dataContact, tpl) {
								var dataParams ={
									firstLanguage: lang,
									urlImageServer: urlImageServer,
									urlHome: urlhome,
									id: codes,
									searchTerm: searchTerm,
									isLine: isLine,
									itemslist: results,
									idLine: idLine
								};
								var rest = pb23MansonyArchtrendsSquared.limit - results.length;
								if (rest > 0)
								{
									pb23MansonyArchtrendsSquared.archtrendsService.getAmbientsByProduct(codes.split(','), rest, null, null, null, false, {
										success: (resultsMore) => {
											console.log(resultsMore);                        
											dataParams.itemslist = results.concat(resultsMore);
											var html = tpl.fetch(dataParams);
											$('.pb23-masonry--archtrends-squared').replaceWith(html);
											initLazyLoad();
											pb23MansonyArchtrendsSquared.initMasonry();
										}
									}
									);
								}
								else
								{
									var html = tpl.fetch(dataParams);
									$('.pb23-masonry--archtrends-squared').replaceWith(html);
									initLazyLoad();
									//pb23MansonyArchtrendsSquared.initMasonry();
								}
							});
                        }
                    });
                }

            }
        });
    },
    initMasonry: function()
    {
		if ($('.pb23-masonry--archtrends-squared .arch-masonry .masonry-item').length > 0)
		{
			/*
			var masonry = new MiniMasonry({
				container: '.arch-masonry',
				//minify: true,
				//direction: 'ltr',
				//wedge: true,
				gutter: 20,
				//basewidth: isMobile?118:340
				basewidth: 450
			});
			*/
		}
		else
		{
			$('#archtrends-masonry').hide();
		}
    }
};

// initialize component
window.loadedComponents.push({ component: "pb23-masonry--archtrends-squared", init: pb23MansonyArchtrendsSquared.init });

export default() => {
    pb23MansonyArchtrendsSquared.init();
}